import { useEffect, useState } from 'react';

import Banner from '@/components/Banner/Banner';
import Button from '@/components/Button/Button';
import { Paragraph } from '@/components/Typography/Typo';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';
import { getTimezoneDayjs } from '@/utils/time';

type Props = {
  topic: Topic2T<TOPIC_2_TYPE>;
  onRefreshClick: () => void;
};

const SavedTopicGuide = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const now = getTimezoneDayjs();
    const createdAt = getTimezoneDayjs(props.topic.created_at);
    const diff = now.diff(createdAt);
    if (diff < 1000 * 60) {
      setIsOpen(true);
    }
  }, [props.topic.created_at]);
  if (!isOpen) return null;

  return (
    <Banner
      flow="horizontal"
      desc={<Paragraph size={3}>Refresh to see the latest data.</Paragraph>}
      buttons={[
        <Button variant="outlined" sizeType="s" onClick={props.onRefreshClick}>
          Refresh
        </Button>,
      ]}
      close={() => setIsOpen(false)}
    />
  );
};

export default SavedTopicGuide;
